import CustomerService from './services';
import CustomerTypes from './types';

export const loadCustomerByEmail = (email: any) => CustomerTypes.byEmail.createAction(() => CustomerService.loadCustomerByEmail(email));
export const loadCustomerById = (id: any) => CustomerTypes.byId.createAction(() => CustomerService.loadCustomerById(id));
export const updateCustomerById = (id: any, obj: any) => CustomerTypes.updateCustomer.createAction(() => CustomerService.updateCustomerById(id, obj));
export const sendCustomerSurvey = (customerId: any, survey: any) =>
  CustomerTypes.sendCustomerSurvey.createAction(() => CustomerService.sendCustomerSurvey(customerId, survey));
export const markOrbitaAbandonment = (customerId: number, reason: string) =>
  CustomerTypes.markOrbitaAbandonment.createAction(() => CustomerService.markOrbitaAbandonment(customerId, reason));
export const checkIfUserhaveCoproductionGains = () =>
  CustomerTypes.hasCoproductionGains.createAction(() => CustomerService.checkIfUserhaveCoproductionGains());
